import { giphyDarkCharcoal, giphyLightCharcoal, giphyLightGrey } from '@giphy/colors'
import { ReactNode, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { Icon, IconComponent } from 'ui'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

const Arrow = styled(IconComponent)`
    display: inline-block;
    margin: 3px 0 0 6px;
    vertical-align: top;
`

const Content = styled.div`
    animation: ${fadeIn} 0.15s ease-out;
`

const SectionIcon = styled(IconComponent)`
    display: inline-block;
    margin: 1px 6px 0 0;
    vertical-align: top;
`

const Title = styled.div`
    color: ${giphyLightGrey};
    cursor: pointer;
    font-size: 13px;
    font-weight: bold;
    line-height: 18px;
    margin-bottom: 6px;
    user-select: none;
`

type Props = {
    children?: ReactNode
    className?: string
    defaultOpen?: boolean
    icon?: Icon
    title: string
}

const CopilotSidebarSection = ({ children, className, defaultOpen = false, icon, title }: Props) => {
    const [isOpen, setIsOpen] = useState<boolean>(defaultOpen)

    function onToggle() {
        setIsOpen((state) => !state)
    }

    return (
        <div className={className}>
            <Title onClick={onToggle}>
                {icon && <SectionIcon color={giphyLightCharcoal} icon={icon} height={16} width={16} />}
                {title}
                <Arrow
                    color={giphyDarkCharcoal}
                    height={12}
                    icon={isOpen ? 'navigate-up' : 'navigate-down'}
                    width={12}
                />
            </Title>
            {isOpen && <Content>{children}</Content>}
        </div>
    )
}

export default CopilotSidebarSection
